const timePipe = (mins) => { 
    const hours = ( mins >= 60 ? Math.trunc(mins/60) : 0);
	let minutes = mins % 60; 
	return hours ? (hours + 'ч ' + (minutes ? (minutes + 'мин') : '')) : (mins + ' мин') ; 
}
 
export default timePipe;